import FullType from '../getFullType.js';
import {reader} from  '../reader.js';
import {subscribe, unsubscribe} from '../queue.js';
import {uuid} from 'uuidv4';

export default class Connection extends FullType(class {}) {
    constructor(sourceType, sourceNode, destType, destNode, action) {
        super();
        this.id = uuid();
        this.sourceNode = sourceNode;
        this.destNode = destNode;
        this.sourceType = sourceType;
        this.sourceId = sourceNode.id;
        this.destType = destType;
        this.destId = destNode.id;
        this.action = action;

        this._sourceType = this.getFullType(sourceType, this.sourceId);
        this.reader = reader(this._sourceType);

        if (action) {
            subscribe(this._sourceType, action);
        }

        // The following variables involve presentational information
        // specifically, how we segment the patch cable to be tidier
       
        this.segmentation = undefined;
    }

    segment() {
        this.segmentation = true;
    }

    getJson() {
        return {
            id: this.id,
            sourceEl: this.getFullType(this.sourceType, this.sourceId),
            destEl: this.getFullType(this.destType, this.destId),
            sourceType: this.sourceType,
            sourceId: this.sourceId,
            destType: this.destType,
            destId: this.destId,
            sourceWindowId: this.sourceNode.zObject ? this.sourceNode.zObject.id : this.sourceNode.id,
            destWindowId: this.destNode.zObject ? this.destNode.zObject.id : this.destNode.id
        };
    }

    dispose() {
        unsubscribe(this._sourceType, this.action);
        this.reader(true);
    }
}
